import { gql } from '@apollo/client';
import client from 'graphql/client';

const INCOMPLETE_JOBS_QUERY = gql`
  query getIncompleteJobs {
    incompleteJobsToContinue {
      id
      uid
      dateUpdated
      completionPercentage
      data {
        location
        position
        siteVisibility
      }
    }
  }
`;

const fetchIncompleteJobsToContinue = () => {
  return client.query({
    query: INCOMPLETE_JOBS_QUERY,
    fetchPolicy: 'network-only',
  });
};

export { fetchIncompleteJobsToContinue };
